import CampaignIcon from "@mui/icons-material/Campaign";
import { CAMPAIGNS, DormitoryServicePath } from "utils/constants";
import permissions from "app/permissions";
import ListCampaigns from "./List";
import CreateCampaign from "./Create";
import EditCampaign from "./Edit";

export const resources = {
  isMenu: true,
  icon: <CampaignIcon />,
  name: DormitoryServicePath + CAMPAIGNS,
  title: "Кампании",
  list: <ListCampaigns />,
  create: <CreateCampaign />,
  createPermission: permissions.canManageDormitoryCampaigns,
  edit: <EditCampaign />,
  editPermission: permissions.canManageDormitoryCampaigns,
  permission: permissions.canPreviewDormitoryCampaigns,
};
